var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sp-tabs',{attrs:{"tabs":_vm.tabs},scopedSlots:_vm._u([{key:"default",fn:function({ tabs }){return [_c('plugin-ids-list',_vm._b({key:_vm.active_index},'plugin-ids-list',tabs[_vm.active_index].componentProps,false))]}}]),model:{value:(_vm.active_index),callback:function ($$v) {_vm.active_index=$$v},expression:"active_index"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }